import React, { PropTypes } from 'react';
//import './styles.scss';
import * as URLConstants from '../../constants';

class SiteFooter extends React.Component {
  constructor(props) {
    super(props);
    //this.state = {};
  }

  render () {
    let featuresURL = `${URLConstants.MarketingRootURL}/#features`,
        pricingURL = `${URLConstants.MarketingRootURL}/#pricing`,
        loginURL = `${URLConstants.AppRootURL}/login`;

    return (
      <footer>
        <div className="SetterBase-row">
          <div className="SetterBase-col SetterBase-large-c-6 copy-cage">
            <div className="SetterBase-row">
              <div className="SetterBase-col SetterBase-large-c-5"><h4 className="copy">© 2016 SiftedWheat LLC</h4></div>
              <div className="SetterBase-col SetterBase-large-c-7"><h4 className="copy">support@setter.io</h4></div>
            </div>
          </div>
          <div className="SetterBase-col SetterBase-large-c-6 nav-btm-cage">
            <ul className="nav-btm nav inline-list">
              <li><a href={featuresURL}>FEATURES</a></li>
              <li><a href={pricingURL}>PRICING</a></li>
              <li><a href="https://s3.amazonaws.com/setter-production/uploads/Setter+EULA.pdf" target="_blank">EULA</a></li>
              {/* <li><Link to="/about" className="">ABOUT</Link></li> */}
              <li><a href={loginURL} className="">LOGIN</a></li>
              {/* <li><a href="http://app.setter.io/register" className="">SIGN UP</a></li> */}
            </ul>
          </div>
        </div>
      </footer>
    );
  }
}

SiteFooter.propTypes = {

};

SiteFooter.defaultProps = {

};

export default SiteFooter;



/** WEBPACK FOOTER **
 ** ../components/SiteFooter/index.js
 **/